import React, { useContext } from 'react'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../contextAPI'
import { QuizQuestionBase } from '../QuizQuestion'

export const WeddingDate: React.FC = () => {
  const { setQuizScreen } = useContext(QuizQuestionContext)
  setQuizScreen(SCREEN_QUIZ_QUESTION.WEDDING_DATE)
  return <QuizQuestionBase hardScreen={SCREEN_QUIZ_QUESTION.WEDDING_DATE} />
}
